export default __webpack_public_path__ + "static/media/online-advertising-256x256.723401c4.png";